import {Component, ViewChild, Output, ElementRef, AfterViewInit, OnInit, EventEmitter, OnDestroy, ChangeDetectorRef} from '@angular/core';
import {ProfileHeaderComponent } from './profile-header/profile-header.component';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {UserService} from "../../services/user.service";
import {initFlowbite} from "flowbite";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {ReportService} from "../../services/report.service";
import {DeviceService} from "../../services/device.service";
import {filter, Observable, Subject, Subscription, take} from "rxjs";
import {selectReport, selectReportError} from "../../state/search/search.selectors";
import {Store} from "@ngrx/store";
import {AppState} from "../../state/app.state";
import {fetchReport, clearReport, updateReport} from "../../state/search/search.actions";
import { SharedService } from 'src/app/services/shared.service';
import { EventTypes } from 'src/app/event-types';
import {Company} from 'src/app/interfaces/company.interface';
import {transformCompanyData} from 'src/app/utils/company.util';
import {updateCompanyIcpScore} from 'src/app/utils/update-company-icp-score.util';
import {selectCompany} from "../../state/report/report.selectors";
import {updateCompany, updateReportStatusInStore} from "../../state/report/report.actions";
import {PopupService} from "../../services/popup.service";
import {SearchService} from "../../services/search.service";
import {TranslateService} from "@ngx-translate/core";
import {selectIsAsideOpen} from "../../state/ui/ui.selectors";
import * as UiActions from "../../state/ui/ui.actions";
import {map, takeUntil} from "rxjs/operators";
import {EchoService} from "../../services/echo.service";
import {AuthService} from "../../services/auth.service";
import {ReportWebSocketService} from "../../services/report-websocket.service";
import {PromptService} from "../../services/prompt.service";

// Animation definition
export const slideHeaderAnimation = trigger('slideHeader', [
  state('visible', style({
    transform: 'translateY(0)',
    opacity: 1
  })),
  state('hidden', style({
    transform: 'translateY(-100%)',
    opacity: 0
  })),
  transition('* => *', [
    animate('400ms ease')
  ])
]);

export const slideAsideAnimation = trigger('slideAside', [
  state('open', style({
    transform: 'translateX(0)',
    opacity: 1,
    visibility: 'visible'
  })),
  state('closed', style({
    transform: 'translateX(100%)',
    opacity: 0,
    visibility: 'hidden'
  })),
  transition('open <=> closed', [
    animate('400ms cubic-bezier(0.4, 0, 0.2, 1)')
  ])
]);

export const widthAnimationAnimation = trigger('widthAnimation', [
  state('aside', style({
    width: '{{width}}'
  }), {
    params: {
      width: 'calc(100% - (24rem + 5rem))'
    }
  }),
  state('noAside', style({
    width: '{{width}}'
  }), {
    params: {
      width: 'calc(100%)' // Default to full width
    }
  }),
  transition('aside <=> noAside', [
    animate('400ms cubic-bezier(0.4, 0, 0.2, 1)')
  ])
]);

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  animations: [
    slideHeaderAnimation,
    slideAsideAnimation,
    widthAnimationAnimation,
  ],
  providers: [ReportWebSocketService] // Each component instance gets its own service
})

export class ReportComponent implements AfterViewInit, OnInit, OnDestroy {

  @ViewChild(ProfileHeaderComponent) profileHeader: ProfileHeaderComponent | undefined;
  @ViewChild('scrollableDiv2') scrollableDiv2: ElementRef;
  @ViewChild('profileHeaderContainer') profileHeaderContainer: ElementRef<HTMLElement>;

  /** Rendered height of the fixed profile header; the content below is padded by it. */
  private measuredHeaderHeight = 0;
  private headerResizeObserver: ResizeObserver | null = null;

  @Output() reportUpdated: EventEmitter<any> = new EventEmitter();

  animationsDisabled: boolean = false

  aside$: Observable<boolean>;
  aside: boolean = false;
  isAnimating = false;
  isVisible = true;

  edit: boolean = false;
  id: string;
  reportId: number = null;
  prompt: string = "";

  report: any = null;
  report$: Observable<any>;

  loading: boolean = true;
  icebreakers: any = [];
  meetingAgendaSteps: any = [];

  education_description:string;
  career_description:string;

  notes: any = [];

  showShareModal: boolean = false;
  showIcpScoreModal: boolean = false;
  showReportLoaderModal: boolean = false;

  showEditPromptModal: boolean = false;
  showCompanyDetailsModal: boolean = false;
  selectedCompanyForModal: any = null;
  showEditRevenueModal: boolean = false;
  revenueShortForModal: string = '';
  revenueLongForModal: string = '';

  showEditContactModal: boolean = false;
  contactEmailsForModal: string[] = [];
  contactPhonesForModal: string[] = [];
  contactTypeForModal: string = 'person';
  assistantPrompt: string = '';
  promptValue: string = null;

  private reportSuccessSubscription: Subscription;
  private reportFailureSubscription: Subscription;
  private routerSubscription: Subscription;

  // personal_background: any;

  company: Company;
  selectedCompany!: any;

  isChangeCompanyModalVisible: boolean = false;

  private sharedSubscription!: Subscription;

  isHeaderVisible = true; // Controls visibility of the header
  lastScrollPosition = 0; // Keeps track of the last scroll position
  paddingTop: string = 'calc(0)';
  isMobile: boolean = false;

  scrollThreshold = 10; // Minimum scroll distance to trigger header visibility change

  tabs = [
    { id: 1, name: 'Person Insights', current: true },
    { id: 2, name: 'Company Insights', current: false },
    { id: 3, name: 'Industry Insights', current: false },
  ]

  sidebarTabs: { id: number, name: string, current: boolean }[] = [
    { id: 1, name: 'Tags', current: true },
    { id: 2, name: 'Assistant', current: true },
    { id: 3, name: 'Edit', current: false },
    { id: 4, name: 'Notes', current: false },
    { id: 5, name: 'Emails', current: false },
    { id: 6, name: 'CRM', current: false },
  ];

  selectedFilters: { category: string, value: string, label: string }[] = [];

  user: any = {};

  private destroy$ = new Subject<void>();
  // Flag to prevent circular updates between report and company subscriptions
  private isUpdatingCompanyFromReport = false;
  // The search_company_id currently rendered as `this.company`. Used to detect
  // an active-company switch by id CHANGE (not by id inequality with the old
  // company, which misses same-id re-picks) so the displayed company is always
  // re-derived when the active company changes.
  private activeSearchCompanyId: any = null;
  // Insights filled live via WebSocket are applied to `this.company` in place but
  // are NOT persisted to the store's search_companies entries. Cache them per
  // company id so re-picking an already-scanned company restores its insights
  // instead of showing empty "Gathering data" cards.
  private insightsByCompanyId = new Map<any, any>();
  // Same store-drift problem as insights: the live compute_icp_score event
  // updates this.company.icp_score in place but is never persisted to the store's
  // search_companies. Cache it per company id so re-picking a company keeps its
  // (already computed) ICP score instead of hiding the header.
  private icpByCompanyId = new Map<any, { icp_score: any; search_company_icp_detail: any }>();

  private boundScrollHandler: () => void;
  private boundOnDivScroll: () => void;
  private boundCheckDeviceType: () => void;
  private boundDetectMobile: () => void;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public userService: UserService,
    public reportService: ReportService,
    private deviceService: DeviceService,
    private store: Store<AppState>,
    private sharedService: SharedService,
    private popupService: PopupService,
    private cdr: ChangeDetectorRef,
    private echoService: EchoService,
    private authService: AuthService,
    private reportWebSocketService: ReportWebSocketService,
    private promptService: PromptService,
    private searchService: SearchService,
    private translate: TranslateService
  ) {
    this.aside$ = this.store.select(selectIsAsideOpen);

    // Create observables for report and reportTags
    this.report$ = this.store.select(selectReport).pipe(
      filter(response => response !== null),
      map(response => ({ ...response.report }))
    );

    // Subscribe to report updates to keep local report in sync
    // This will handle updates when enrichment occurs
    this.report$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(report => {
      if (report && this.report && report.id === this.report.id) {

        // --- Active company switched (change-company feature) ---
        // When search_company_id now points at a DIFFERENT company, the whole
        // company changed (name, logo, insights, …), not just a few insights.
        // Swap the report wholesale (do NOT re-merge the previous company's
        // insights over the new ones) and re-derive the displayed company from
        // the newly active search_companies entry.
        const incomingCompany = report.search_companies?.find(
          (company: any) => company.id === report.search_company_id
        );

        // Fire whenever the ACTIVE company changes (search_company_id differs
        // from what we last rendered). Comparing against the previously-rendered
        // search_company_id — instead of incomingCompany.id !== this.company.id —
        // also catches same-id re-picks and A→B→A switches, which the id-inequality
        // check missed (leaving the old company on screen).
        if (incomingCompany && report.search_company_id !== this.activeSearchCompanyId) {
          this.report = { ...report };
          this.activeSearchCompanyId = report.search_company_id;

          // Push the switched report to reportService.report$ so its subscribers
          // (person-contact, background, …) follow the company switch — that
          // stream is otherwise only fed on initial load, so they would keep
          // showing the previously-selected company's data.
          this.reportService.updateReport(this.report);

          // Guard against the selectCompany subscription bouncing this back.
          this.isUpdatingCompanyFromReport = true;
          this.company = transformCompanyData(incomingCompany, this.report);

          // If the store has no insights for this company (its live WebSocket
          // fills were never persisted to search_companies), restore the ones we
          // captured while it was last active — so re-picking an already-scanned
          // company shows its data instead of stuck "Gathering data" cards.
          const cachedInsights = this.insightsByCompanyId.get(incomingCompany.id);
          const hasInsights = this.company.insights && Object.keys(this.company.insights).length > 0;
          if (cachedInsights && Object.keys(cachedInsights).length > 0 && !hasInsights) {
            this.company = { ...this.company, insights: cachedInsights };
          }

          // Same for the ICP score: restore the computed value if the store entry
          // has none, so the ICP header doesn't blank out on a re-pick.
          const cachedIcp = this.icpByCompanyId.get(incomingCompany.id);
          if (cachedIcp && this.company.icp_score == null && cachedIcp.icp_score != null) {
            this.company = {
              ...this.company,
              icp_score: cachedIcp.icp_score,
              search_company_icp_detail: cachedIcp.search_company_icp_detail,
            };
          }

          this.store.dispatch(updateCompany({ company: this.company }));
          setTimeout(() => {
            this.isUpdatingCompanyFromReport = false;
          }, 100);

          this.cdr.detectChanges();
          return;
        }

        // Update local report with the latest data, including enrichment status
        // IMPORTANT: Merge insights instead of replacing to preserve WebSocket updates
        this.report = {
          ...report,
          insights: {
            ...report.insights,
            ...this.report.insights // Keep local insights that came from WebSocket
          }
        };

        // Also update the company from the report's search_companies
        // This ensures company stays in sync when report.search_companies is updated (e.g., revenue edit)
        const currentCompany = this.report.search_companies?.find(
          (company: any) => company.id === this.report.search_company_id
        );

        if (currentCompany && this.company) {
          // Check which specific insights have changed and only update those
          const currentCompanyInsights = currentCompany.insights || {};
          const localCompanyInsights = this.company.insights || {};

          // Find insights that have actually changed
          let hasChanges = false;
          const updatedInsights = { ...localCompanyInsights };

          for (const key in currentCompanyInsights) {
            const currentInsight = JSON.stringify(currentCompanyInsights[key]);
            const localInsight = JSON.stringify(localCompanyInsights[key]);

            if (currentInsight !== localInsight) {
              updatedInsights[key] = currentCompanyInsights[key];
              hasChanges = true;
            }
          }

          if (hasChanges) {
            // Set flag to prevent circular update
            this.isUpdatingCompanyFromReport = true;

            // Update only the insights, keeping everything else the same
            this.company = {
              ...this.company,
              insights: updatedInsights
            };

            // Update company store as well
            this.store.dispatch(updateCompany({ company: this.company }));

            // Reset flag after a short delay (after store update propagates)
            setTimeout(() => {
              this.isUpdatingCompanyFromReport = false;
            }, 100);
          }
        }

        // Trigger change detection to update the view
        this.cdr.detectChanges();
      }
    });

    // Subscribe to company updates from the store
    // This ensures the component reacts to company changes (e.g., revenue edits)
    this.store.select(selectCompany).pipe(
      takeUntil(this.destroy$)
    ).subscribe(company => {
      // Skip if this update is coming from the report subscription (prevent circular update)
      if (this.isUpdatingCompanyFromReport) {
        return;
      }

      if (company && this.report) { // Only update if report is ready
        // Update local company reference to trigger change detection in child components
        this.company = { ...company };
        // Manually trigger change detection only if component is initialized
        if (this.reportId) {
          this.cdr.detectChanges();
        }
      }
    });

  }

  applyAnimations() {
    // Update animation enabled status based on device type
    this.animationsDisabled = !this.deviceService.getIsDesktop();
  }

  ngOnInit(): void {
    // Initialize with aside closed on mobile, open on desktop
    this.detectMobile();
    this.aside = !this.isMobile;

    // Initial close of aside on mobile
    if (this.isMobile) {
      this.store.dispatch(UiActions.toggleAside({ isOpen: false }));
    }

    this.updatePaddingTop();

    this.boundCheckDeviceType = this.checkDeviceType.bind(this); // Bind and store
    window.addEventListener('resize', this.boundCheckDeviceType);

    this.boundDetectMobile = this.detectMobile.bind(this); // Bind and store
    window.addEventListener('resize', this.boundDetectMobile);

    /*
    this.route.params.subscribe(routeParams=> {

      this.id = this.route.snapshot.paramMap.get('id');
      this.reportId = parseInt(this.route.snapshot.paramMap.get('id'));

      this.fetchReport(this.reportId)
    })
    */

    // Subscribe to router events to close aside on navigation on mobile
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.isMobile) {
        this.closeAsideIfMobile();
      }
    });

    this.route.params.subscribe(routeParams => {
      this.id = this.route.snapshot.paramMap.get('id');
      this.reportId = parseInt(this.route.snapshot.paramMap.get('id'));
      this.fetchReport(this.reportId);

      // Close aside on navigation
      if (this.isMobile) {
        this.closeAsideIfMobile();
      }
    });

    setTimeout(() => {
      initFlowbite();
    }, 1000);

    this.applyAnimations();

    if (!this.deviceService.getIsDesktop()) {
      this.personExpanded = false
      this.companyExpanded = false
    }

    this.listenForChangeCompany()

    this.setCompanyFromStore()

    // Add your mobile detection logic here
    this.detectMobile();

    // Initialize WebSocket connection after user and report are loaded
    this.authService.authUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.user = user;

        // Connect to report-specific WebSocket channel after both user and reportId are available
        if (this.user && this.user.id && this.reportId) {
          this.reportWebSocketService.connectToReportChannel(
            this.user.id,
            this.reportId,
            (reportEvent) => this.handleReportWebSocketEvent(reportEvent)
          );
        }
      });

    // Also connect when report is successfully fetched
    this.report$.pipe(takeUntil(this.destroy$)).subscribe(report => {
      if (report && this.user && this.user.id) {
        this.reportWebSocketService.connectToReportChannel(
          this.user.id,
          report.id,
          (reportEvent) => this.handleReportWebSocketEvent(reportEvent)
        );
      }
    });

  }

  /**
   * Handle WebSocket events for this specific report instance
   * This is called by the WebSocket service when events are received
   * It keeps the state updates isolated to this component instance
   */
  private handleReportWebSocketEvent(reportEvent: any): void {
    // Handle report fully completed (search_status -> 3). The new-report pipeline
    // fires the "data ready" banner at status 2 — BEFORE the insight jobs persist
    // their results — so a report opened around then can show empty
    // "Gathering data" cards. Re-fetch once on true completion so the late
    // insights merge in (via the report$ subscription) without a manual refresh.
    // Dispatch the action (not the component method) to avoid clearing the
    // company / resetting scroll: the report$ merge branch fills the cards in place.
    // This is handled BEFORE the not-ready guard below because the dispatch is
    // independent of this.company/this.report — so a completion event arriving
    // during the fresh-load/new-tab fetch window is never dropped.
    if (reportEvent.eventType === 'search-report-completed') {
      if (this.report?.search_status_id !== 3) {
        this.store.dispatch(fetchReport({ reportId: this.reportId }));
      }
      return;
    }

    if (!this.company || !this.report) {
      console.warn('⚠️ [Report] Event received but component not ready');
      return;
    }

    // Handle apollo-phone-number event
    if (reportEvent.eventType === 'apollo-phone-number') {
      this.sharedService.emitEvent(EventTypes.APOLLO_PHONE_NUMBER, {
        message: 'Reload Phone Numbers',
        report_id: reportEvent.id || reportEvent.report_id,
        report_name: reportEvent.name,
        phone_numbers: reportEvent.phone_numbers
      });
      return;
    }

    // Handle notes-summary event
    if (reportEvent.eventType === 'notes-summary') {
      // Emit event to notes component
      this.sharedService.emitEvent(EventTypes.LOAD_NOTES_SUMMARY, {
        message: 'Load Notes Summary',
        response: reportEvent.prompt
      });

      // Also update the report store with the notes summary
      this.store.select(selectReport).pipe(take(1)).subscribe(reportResponse => {
        if (reportResponse?.report && reportResponse.report.id === this.reportId) {
          const updatedReport = {
            ...reportResponse.report,
            insights: {
              ...reportResponse.report.insights,
              notes_summary: {
                status: 'finished',
                response: reportEvent.prompt,
                tag: 'ASK_ASSISTANT_NOTES_SUMMARY'
              }
            }
          };
          this.store.dispatch(updateReport({ report: updatedReport }));
        }
      });

      return;
    }

    // Only process events for THIS report
    const eventReportId = reportEvent.search_id ? parseInt(reportEvent.search_id, 10) : null;
    if (eventReportId !== this.reportId) {
      return; // Silently ignore events for other reports
    }

    const promptTagToUpdate = reportEvent.field_name;
    let responseData = reportEvent.data || reportEvent.response;

    // Parse JSON string if needed
    if (typeof responseData === 'string') {
      try {
        responseData = JSON.parse(responseData);
      } catch (e) {
        console.error(`❌ [Report] JSON parse error`, { field: promptTagToUpdate });
      }
    }

    // The insight jobs broadcast the raw OpenAI choice object
    // ({ message: { content }, ... }, or { choices: [ ... ] }). Unwrap it to the
    // inner content so it matches the stored/SearchData shape — otherwise the
    // assistant-prompt card renders the object as "[object Object]".
    {
      const choice = Array.isArray(responseData?.choices) ? responseData.choices[0] : responseData;
      if (choice && typeof choice === 'object' && choice.message && typeof choice.message.content === 'string') {
        responseData = choice.message.content;
      }
    }

    // ICP score recompute event — update the active company's score directly so
    // the ICP header refreshes (e.g. after a company switch recomputes it). This
    // is not an assistant-prompt insight, so handle it separately and return.
    if (promptTagToUpdate === 'compute_icp_score' && responseData) {
      const newIcpScore = responseData.icp_score ?? null;
      this.company = updateCompanyIcpScore(this.company, newIcpScore, responseData.icp_details ?? null);
      // Cache the live ICP so re-picking this company restores it.
      if (this.company?.id != null) {
        this.icpByCompanyId.set(this.company.id, {
          icp_score: this.company.icp_score,
          search_company_icp_detail: this.company.search_company_icp_detail,
        });
      }
      this.store.dispatch(updateCompany({ company: this.company }));
      this.cdr.detectChanges();
      return;
    }

    // Update local company state with new field data
    if (promptTagToUpdate && responseData !== undefined && responseData !== null) {
      // Convert tag name to insight key (e.g., 'ASK_ASSISTANT_PERSONAL_BACKGROUND' -> 'personal_background')
      const TAG_TO_INSIGHT_KEY_MAP: { [key: string]: string } = {
        'ASK_ASSISTANT_ABOUT_COMPANY': 'about_company',
        'ASK_ASSISTANT_COMPANY_REVENUE': 'company_revenue',
        'ASK_ASSISTANT_SPECIAL_BOX': 'special_box',
        'ASK_ASSISTANT_SALES_INSIGHTS': 'sales_insights',
        'ASK_ASSISTANT_PERSONAL_BACKGROUND': 'personal_background',
        'ASK_ASSISTANT_INITIAL_OUTREACH': 'initial_outreach',
        'ASK_ASSISTANT_BASIC_WORDS_IN_LOCAL_LANGUAGE': 'basic_words',
        'ASK_ASSISTANT_C_LEVEL': 'c_level',
        'ASK_ASSISTANT_COMPANY_NEWS': 'company_news',
        'ASK_ASSISTANT_EMAIL_SEQUENCE': 'email_sequence',
        'ASK_ASSISTANT_LINKEDIN_SEQUENCE': 'linkedin_sequence',
        'ASK_ASSISTANT_EDUCATION_INSIGHT': 'education_insight',
        'ASK_ASSISTANT_ADVANCED_CAREER': 'advanced_career',
        'ASK_ASSISTANT_DEPARTMENT_YEARS': 'department_years',
        'ASK_ASSISTANT_EXPERTISE_AREAS': 'expertise_areas',
        'ASK_ASSISTANT_EXPLORATORY_EMAIL_EXAMPLE': 'exploratory_email_example',
        'ASK_ASSISTANT_INDUSTRY_CHALLENGES': 'industry_challenges',
        'ASK_ASSISTANT_INSIGHTS_ABOUT_CAREER': 'insights_about_career',
        'ASK_ASSISTANT_MANAGEMENT_EXPERIENCE': 'management_experience',
        'ASK_ASSISTANT_MEETING_AGENDA': 'meeting_agenda',
        'ASK_ASSISTANT_TOTAL_BUSINESS_TENURE': 'total_business_tenure',
        'ASK_ASSISTANT_YEARS_IN_CURRENT_COMPANY': 'years_in_current_company'
      };

      const insightKey = TAG_TO_INSIGHT_KEY_MAP[promptTagToUpdate] || promptTagToUpdate;

      // Create the updated insight object
      const updatedInsight = {
        ...this.company.insights?.[insightKey],
        response: responseData,
        status: 'finished',
        generated: true,
        updated_at: new Date().toISOString()
      };

      // Update the insights object in local company state
      this.company = {
        ...this.company,
        insights: {
          ...this.company.insights,
          [insightKey]: updatedInsight
        }
      };

      // Cache this company's live insights so re-picking it later restores them
      // (these fills are not written back to the store's search_companies entry).
      if (this.company?.id != null) {
        this.insightsByCompanyId.set(this.company.id, this.company.insights);
      }

      // ALSO update the report.insights so ai-agent-tool-box can detect the change
      if (this.report) {
        this.report = {
          ...this.report,
          insights: {
            ...this.report.insights,
            [insightKey]: updatedInsight
          }
        };
      }

      // Notify all AssistantPromptComponents for this specific report
      // Components will filter by reportId to only update relevant instances
      this.promptService.notifyPromptUpdate(promptTagToUpdate, responseData, this.reportId);

      // Trigger change detection to update the view
      this.cdr.detectChanges();
    }
  }

  private detectMobile() {
    const checkMobile = () => {
      this.isMobile = window.innerWidth < 768;
      // If switching to mobile, ensure aside is closed
      if (this.isMobile) {
        this.aside = false;
      }
    };

    // Initial check
    checkMobile();

    // Add debounced resize listener
    window.addEventListener('resize', () => {
      // Using requestAnimationFrame for better performance
      requestAnimationFrame(() => {
        checkMobile();
      });
    });
  }

  /**
   * Closes the aside panel if the device is mobile
   */
  private closeAsideIfMobile(): void {
    if (this.isMobile) {
      this.store.dispatch(UiActions.toggleAside({ isOpen: false }));
      this.aside = false;
    }
  }

  private checkDeviceType(): void {
    this.isMobile = window.innerWidth <= 768;
  }

  ngAfterViewInit() {
    if (this.scrollableDiv2 && this.scrollableDiv2.nativeElement) {
      this.boundScrollHandler = this.scrollHandler.bind(this);
      this.scrollableDiv2.nativeElement.addEventListener('scroll', this.boundScrollHandler);

      this.boundOnDivScroll = this.onDivScroll.bind(this);
      this.scrollableDiv2.nativeElement.addEventListener('scroll', this.boundOnDivScroll);
    }

    // Block scrolling on body
    this.enableScrollBlock();

    this.observeHeaderHeight();
  }

  private observeHeaderHeight(): void {
    const header = this.profileHeaderContainer?.nativeElement;
    if (!header || typeof ResizeObserver === 'undefined') {
      return;
    }

    this.headerResizeObserver = new ResizeObserver(() => {
      const height = Math.ceil(header.getBoundingClientRect().height);
      if (height > 0 && height !== this.measuredHeaderHeight) {
        this.measuredHeaderHeight = height;
        this.updatePaddingTop();
      }
    });
    this.headerResizeObserver.observe(header);
  }

  private isUpdatingHeader = false; // Add a flag to track updates

  onDivScroll(): void {
    if (this.isMobile) {
      const scrollElement = this.scrollableDiv2.nativeElement;
      const currentScrollPosition = scrollElement.scrollTop;
      const scrollDifference = currentScrollPosition - this.lastScrollPosition;

      // Calculate scroll percentage for mobile only
      const maxScroll = scrollElement.scrollHeight - scrollElement.clientHeight;
      const scrollPercentage = (currentScrollPosition / maxScroll) * 100;

      // Prevent multiple updates while already updating the header
      if (this.isUpdatingHeader) return;

      if (Math.abs(scrollDifference) > this.scrollThreshold) {
        this.isUpdatingHeader = true;

        // Update header visibility
        if (scrollDifference > 0 && currentScrollPosition > 100) {
          this.isHeaderVisible = false;
        } else if (scrollDifference < 0 && scrollPercentage < 95) {
          // Only show header if we're not in the bottom 5% of the content on mobile
          this.isHeaderVisible = true;
        }

        this.cdr.detectChanges();

        // Allow updates after a short delay
        setTimeout(() => {
          this.isUpdatingHeader = false;
        }, 200); // Adjust debounce time
      }

      this.lastScrollPosition = currentScrollPosition;
    }

    this.updatePaddingTop();
  }

  enableScrollBlock(): void {
    document.body.style.overflow = 'hidden'; // Disable scrolling on the body
  }

  disableScrollBlock(): void {
    document.body.style.overflow = ''; // Restore scrolling on the body
  }

  private updatePaddingTop(): void {
    const isMobile = window.innerWidth <= 768;

    if (!this.isHeaderVisible && isMobile) {
      // When header is hidden on mobile, use minimal padding
      this.paddingTop = '0rem'; // Add a small padding to prevent content from touching the top
    } else if (this.measuredHeaderHeight > 0) {
      this.paddingTop = `${this.measuredHeaderHeight}px`;
    } else {
      let basePadding = 0;

      if (isMobile) {
        basePadding = this.personExpanded && this.companyExpanded ? 18 : 18;
      } else {
        basePadding = this.personExpanded && this.companyExpanded ? 21 : 9.4; //  20.2 : 9.4;
      }

      this.paddingTop = `calc(${basePadding}rem + ${this.extraHeight}px)`;
    }

    // Use ChangeDetectorRef to ensure the view updates
    this.cdr.detectChanges();
  }


  /**
   * Updates the `company` property with the latest value from the store.
   *
   * DISABLED: We no longer use the global store for company updates to prevent
   * cross-tab contamination. Each component maintains its own company state.
   *
   * @author Sabin Nițu
   * @returns {void}
   */
  setCompanyFromStore(): void {
    // DISABLED: Don't subscribe to global company store
    // Each tab maintains its own company state to prevent contamination
  }

  /**
   * Subscribes to the `companyUpdated$` observable from the `SharedService`
   * to listen for updates to the company. When a new company is emitted,
   * dispatches an action to update the company in the store.
   *
   * This ensures that the latest company data is reflected in the application state.
   *
   * @author Sabin Nițu
   * @returns {void}
   */
  listenForChangeCompany(): void {
    this.sharedSubscription = this.sharedService.companyUpdated$.subscribe((updatedCompany) => {

      // Dispatch the action to update the company in the store
      this.store.dispatch(updateCompany({ company: updatedCompany }))

    });
  }

  closeModal(): void {
    this.isChangeCompanyModalVisible = false;
    this.cdr.detectChanges(); // Trigger change detection
  }

  /**
   * Fetches a report by its unique identifier (`reportId`) and handles the success and failure scenarios.
   *
   * On success:
   * - Updates the local report data and sets the associated company.
   * - Dispatches an update to the store and refreshes the application view.
   *
   * On failure:
   * - Logs the error and redirects the user to the `/reports` page.
   * - Notifies the user with a popup message describing the failure.
   *
   * This function ensures that the application state reflects the latest report data
   * while handling any errors gracefully to maintain a seamless user experience.
   *
   * @param {number} reportId - The unique identifier of the report to be fetched.
   *
   * @author Sabin Nițu
   * @returns {void}
   */
  fetchReport(reportId: number): void {
    this.loading = true;

    // The report route is REUSED across /report/:id → /report/:otherId
    // navigations (see CustomReuseStrategy), so this component and its nested
    // assistant-prompt cards are NOT recreated — only the route param changes.
    // Reset the displayed company so the reused cards get a clean
    // null → new-company transition (identical to a fresh page load, which is
    // why a manual refresh "fixes" it) and re-read the new report's insights,
    // instead of keeping the previous report's company bound and showing stuck
    // "Gathering data..." cards. activeSearchCompanyId is cleared too so a later
    // switch is still detected by id change.
    this.company = null;
    this.activeSearchCompanyId = null;

    // Clear the current report from the store before fetching a new one
    this.store.dispatch(clearReport());

    this.store.dispatch(fetchReport({ reportId }));

    // Tear down any still-pending fetch from a previous navigation so its
    // take(1) can't resolve THIS navigation with the wrong report.
    this.reportSuccessSubscription?.unsubscribe();
    this.reportFailureSubscription?.unsubscribe();

    this.reportSuccessSubscription = this.store.select(selectReport)
      .pipe(
        // Only accept the report we actually asked for. Guards against a stale
        // in-flight emission (or the previous report) resolving this fetch with
        // a company that lacks the new report's insights.
        filter(response => response !== null && Number(response.report?.id) === reportId),
        take(1)
      )
      .subscribe(response => {
        const report = response.report

        this.report = { ...report }; // Create a new object reference

        this.setCompany()

        this.reportService.updateReport(report)

        this.loading = false;
        this.cdr.detectChanges();

        // Opening a (different) report should start at the top. The report route
        // is reused across /report/:id changes, so the scroll container keeps the
        // previous report's position — reset it so a freshly opened report (e.g.
        // via the recommendations "View Report" button) doesn't appear mid-page.
        if (this.scrollableDiv2?.nativeElement) {
          this.scrollableDiv2.nativeElement.scrollTop = 0;
        }

      });

    this.reportFailureSubscription = this.store.select(selectReportError)
      .pipe(filter(error => error !== null), take(1))
      .subscribe(error => {
        console.error('Error fetching report:', error);

        // Redirect to /404
        this.router.navigate(['/reports']);

        const errorMessage = error.error?.message || 'Failed to open report.';
        this.popupService.notify(errorMessage, 'Error', 'error');

        this.loading = false;
      });
  }

  setCompany() {
    const currentCompany = this.report.search_companies.find(
      (company: any) => company.id === this.report.search_company_id
    );

    if (currentCompany) {
      // Transform the company data
      const company = transformCompanyData(currentCompany, this.report);

      // Store company in component
      this.company = company;
      // Record the active company so a later switch is detected by id change.
      this.activeSearchCompanyId = this.report.search_company_id;

      // Dispatch the action to update the company in the store
      this.store.dispatch(updateCompany({ company: company }));

      // Also ensure the report has insights from the current company
      if (currentCompany.insights) {
        this.report = {
          ...this.report,
          insights: currentCompany.insights
        };
      }
    }
  }

  /*
  setCompany() {
    // console.log('[report.component.ts] setCompany')

    const currentCompany = this.report.search_companies.find(
      (company: any) => company.id === this.report.search_company_id
    );

    if (currentCompany) {
      const company = transformCompanyData(currentCompany, this.report);

      // Dispatch the action to update the company in the store
      this.store.dispatch(updateCompany({ company: company }))
    }

  }
  */

  personExpanded: boolean | undefined = true
  companyExpanded: boolean | undefined = true
  extraHeight: number = 0;

  private scrollHandler(event: Event): void {
    // Handle tab section highlighting
    const currentSectionId = this.getCurrentSection();
    if (this.profileHeader) {
      this.profileHeader.setActiveTab(currentSectionId);
    }

    const target = event.target as HTMLElement;
    const isAtTop = target.scrollTop === 0;

    // Handle desktop profile expansion
    if (this.deviceService.getIsDesktop()) {
      if (isAtTop) {
        // At top of scroll - expand profiles if not already expanded
        if (!this.personExpanded || !this.companyExpanded) {
          this.profileHeader?.expandPersonAndCompany(true);
        }
      } else {
        // Not at top - collapse profiles if not already collapsed
        if (this.personExpanded || this.companyExpanded) {
          this.profileHeader?.expandPersonAndCompany(false);
        }
      }
    }
  }

  ngOnDestroy() {

    this.headerResizeObserver?.disconnect();

    if (this.scrollableDiv2 && this.scrollableDiv2.nativeElement) {
      this.scrollableDiv2.nativeElement.removeEventListener('scroll', this.boundScrollHandler);
      this.scrollableDiv2.nativeElement.removeEventListener('scroll', this.boundOnDivScroll);
    }

    // Disconnect from WebSocket channel for this specific report
    if (this.user && this.user.id && this.reportId) {
      this.reportWebSocketService.disconnectFromReportChannel(this.user.id, this.reportId);
    }

    // Complete the destroy$ subject to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();

    this.store.dispatch(clearReport());

    this.reportSuccessSubscription?.unsubscribe();
    this.reportFailureSubscription?.unsubscribe();

    this.report = null;
    this.reportId = null;

    window.removeEventListener('resize', this.boundCheckDeviceType);
    window.removeEventListener('resize', this.boundDetectMobile);

    // Restore scrolling on body
    this.disableScrollBlock();
  }

  private getCurrentSection(): string | null {
    const div = this.scrollableDiv2?.nativeElement;
    if (!div) return null;

    const sections = div.querySelectorAll('div[id]');
    let currentSectionId = null;
    let closestDistance = Number.MAX_VALUE;

    sections.forEach((section: HTMLElement) => {
      const sectionTop = section.offsetTop - div.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;
      const scrollPosition = div.scrollTop;

      // Check if the section is currently visible in the viewport
      if (sectionTop <= scrollPosition && sectionBottom > scrollPosition) {
        // Determine how close the top of the section is to the top of the viewport
        const distance = Math.abs(sectionTop - scrollPosition);
        if (distance < closestDistance) {
          closestDistance = distance;
          currentSectionId = section.id;
        }
      }
    });

    return currentSectionId;
  }

  receiveAside(event: any) {
    this.aside = event
  }

  receiveSidebarTabs(data: any) {
    this.sidebarTabs = data
    this.aside = true
  }

  handleAsideStateChange(state: { isOpen: boolean; isClosing: boolean }) {
    this.isAnimating = true;
    if (state.isClosing) {
      setTimeout(() => {
        if (!state.isOpen) {  // Double check the state hasn't changed
          this.isAnimating = false;
        }
      }, 400); // Match animation duration
    }
  }

  onAnimationDone(event: any) {
    if (event.toState === 'closed') {
      this.isAnimating = false;
    }
  }

  receiveEdit(edit: boolean) {
    this.edit = edit
  }

  // Update the height when received from profile-header
  updateTagsHeight(height: number) {
    this.extraHeight = height;
  }

  receiveExpandedPersonAndCompany(expanded: boolean | undefined) {
    this.personExpanded = expanded
    this.companyExpanded = expanded
  }

  openShareModal() {
    this.showShareModal = true;
  }

  // ---- Regenerate insights (1 credit) --------------------------------------
  // Rendered at the report root (not inside the animated header) so the modal
  // overlay covers the whole viewport — a transformed ancestor would otherwise
  // trap position:fixed.
  showRegenerateModal: boolean = false;
  regenerating: boolean = false;

  openRegenerateModal() {
    if (this.regenerating) { return; }
    this.showRegenerateModal = true;
  }

  cancelRegenerate() {
    this.showRegenerateModal = false;
  }

  confirmRegenerate() {
    const reportId = this.report?.id ?? this.reportId;
    if (!reportId || this.regenerating) { return; }

    this.regenerating = true;
    this.showRegenerateModal = false;

    this.searchService.regenerateReport(reportId).subscribe({
      next: () => {
        this.regenerating = false;
        // Flip to the "Gathering data" pulse until 'search-report-completed'
        // re-fetches the report with status 3.
        if (this.report) {
          this.report = { ...this.report, search_status_id: 2 };
        }
        this.popupService.notify(this.translate.instant('report.regenerate.started'), '', 'success');
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.regenerating = false;
        const status = err?.status;
        const message = status === 402
          ? this.translate.instant('report.regenerate.insufficient_credits')
          : status === 409
            ? this.translate.instant('report.regenerate.in_progress')
            : (err?.error?.message || this.translate.instant('report.regenerate.failed'));
        this.popupService.notify(message, '', status === 402 ? 'warning' : 'error');
        this.cdr.detectChanges();
      },
    });
  }

  openReportLoaderModal() {
    this.showReportLoaderModal = true;
  }

  handleShareModalClose() {
    this.showShareModal = false;
  }

  handleReportLoaderModalClose() {
    this.showReportLoaderModal = false;
  }

  // Called when the icpScoreClicked event is emitted
  openIcpScoreModal() {
    this.showIcpScoreModal = true; // Show the ICP Score modal
  }

  // Called when the modal emits 'modalClosed'
  handleIcpScoreModalClose() {
    this.showIcpScoreModal = false; // Hide the ICP Score modal
  }

  // Method that will be triggered when the event is emitted
  onEditPromptToggled(eventData: { visible: boolean, assistantPrompt: string, promptValue: string }) {
    this.showEditPromptModal = eventData.visible;
    this.assistantPrompt = eventData.assistantPrompt;
    this.promptValue = eventData.promptValue;
  }

  // Handle closing of the modal
  handleEditPromptModalClose() {
    this.showEditPromptModal = false;
  }

  // Handle company details modal
  openCompanyDetailsModal(companyData: any) {
    this.selectedCompanyForModal = companyData;
    this.showCompanyDetailsModal = true;
  }

  handleCompanyDetailsModalClose() {
    this.showCompanyDetailsModal = false;
    this.selectedCompanyForModal = null;
  }

  // Handle edit revenue modal
  openEditRevenueModal(revenueData: {short: string, long: string}) {
    this.revenueShortForModal = revenueData.short;
    this.revenueLongForModal = revenueData.long;
    this.showEditRevenueModal = true;
  }

  handleEditRevenueModalClose() {
    this.showEditRevenueModal = false;
    this.revenueShortForModal = '';
    this.revenueLongForModal = '';
  }

  // Handle edit contact modal
  openEditContactModal(data: { emails: string[]; phoneNumbers: string[]; contactType?: string }) {
    this.contactEmailsForModal = data.emails;
    this.contactPhonesForModal = data.phoneNumbers;
    this.contactTypeForModal = data.contactType || 'person';
    this.showEditContactModal = true;
  }

  handleEditContactModalClose() {
    this.showEditContactModal = false;
    this.contactEmailsForModal = [];
    this.contactPhonesForModal = [];
    this.contactTypeForModal = 'person';
  }

  handleContactUpdated(data: { emails: string[]; phoneNumbers: string[]; contactType: string }) {
    // Create a new report object reference so Angular change detection
    // pushes the update down to child components via @Input bindings
    this.report = { ...this.report };
  }

  updateSelectedFilters(filters: { category: string, value: string, label: string }[]): void {
    this.selectedFilters = filters;
  }

  onReportStatusChanged(statusChange: { previousStatus: number, newStatus: number }): void {
    // Handle different status transitions
    if (statusChange.previousStatus === 1 && statusChange.newStatus === 2) {
      // Maybe show a notification
      // this.popupService.notify('Profile enrichment completed!', 'Success', 'success');
    }

    if (statusChange.newStatus === 3) {
      // Hide any loading indicators
      this.loading = false;
      // Maybe refresh some data
      this.cdr.detectChanges();
    }
  }

// Optional: Add a method to manually check/update status
  checkReportStatus(): void {
    if (this.report && this.report.search_status_id) {
      // You can also dispatch actions based on status
      if (this.report.search_status_id === 3) {
        // Report is complete, maybe update UI
        this.loading = false;
      }
    }
  }

  protected readonly state = state;

  protected readonly JSON = JSON;

  /*
  // Method to calculate the top padding
  calculatePaddingTop(): string {
    console.log('calculatePaddingTop')

    // When the header is not visible, return 'calc(0)'
    if (!this.isHeaderVisible) {
      return 'calc(0)';
    }

    let basePadding = 0;

    // Check if display is mobile (you can define the breakpoint; typically < 768px)
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {

      if (this.personExpanded && this.companyExpanded) {
        basePadding = 21; // base padding for person and company expanded
      } else {
        basePadding = 18; // base padding for not both expanded
      }

    } else {

      if (this.personExpanded && this.companyExpanded) {
        basePadding = 21.1; // base padding for person and company expanded
      } else {
        basePadding = 9.4; // base padding for not both expanded
      }

    }

    // Return padding-top value in rem + extraHeight in px
    return `calc(${basePadding}rem + ${this.extraHeight}px)`;
  }
  */

}
